/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCompanionSessionDto
 */
export interface CreateCompanionSessionDto {
    /**
     * セッション名（用途識別子）。同一 auth tenant × ユーザー × sessionName で companion セッションは常に1本になる（置き換え）。
     * 「サービス名-用途」の形式を推奨する。
     * @type {string}
     * @memberof CreateCompanionSessionDto
     */
    sessionName: string;
}

/**
 * Check if a given object implements the CreateCompanionSessionDto interface.
 */
export function instanceOfCreateCompanionSessionDto(value: object): value is CreateCompanionSessionDto {
    if (!('sessionName' in value) || value['sessionName'] === undefined) return false;
    return true;
}

export function CreateCompanionSessionDtoFromJSON(json: any): CreateCompanionSessionDto {
    return CreateCompanionSessionDtoFromJSONTyped(json, false);
}

export function CreateCompanionSessionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCompanionSessionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'sessionName': json['sessionName'],
    };
}

export function CreateCompanionSessionDtoToJSON(json: any): CreateCompanionSessionDto {
    return CreateCompanionSessionDtoToJSONTyped(json, false);
}

export function CreateCompanionSessionDtoToJSONTyped(value?: CreateCompanionSessionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sessionName': value['sessionName'],
    };
}

